export enum NetworkSetupTitleEnum {
  Instructions = 'About',
  Suggestions = 'Suggestions',
  FamilyUsers = 'Family Users',
  Status = 'Status',
  ProfessionalUsers = 'Professional Users',
  Clients = 'Clients',
  Professionals = 'Professionals',
}
